import {createContext, useContext} from 'react';

import {DefaultFoundationTheme, foundationTheme} from '../utils/foundationTheme';

export const FoundationThemeContext = createContext<DefaultFoundationTheme>(foundationTheme);

export function useFoundationTheme() {
  return useContext(FoundationThemeContext);
}
